export const CategoryTypeEnum = {
    Product: 1,
    BillPayment: 2
}

export const ActionEnum = {
    Approve: 1,
    ApproveWithTerms: 2,
    Edit: 3,
    Cancel: 4,
    Reopen: 5,
    RejectQuotation: 6,
}

export const ActionEnumDescription = {
    ApproveQuotation: "Aprovar cotação",
    ApproveQuotationWithTerm: "Aprovar cotação com termo",
    Approve: "Aprovar",
    ApproveRedemption: "Aprovar Resgate",
    ApproveWithTerms: "Aprovar com termo",
    Edit: "Editar solicitação",
    Cancel: "Cancelar solicitação",
    Reopen: "Reabrir solicitação",
    RejectQuotation: "Rejeitar cotação",
}

export const StepStatusEnum = {
    Approved: 1,
    InApproval: 2,
    Pending: 3,
    Canceled: 4
}

export const StepStatusEnumDescription = {
    Approved: "Aprovado",
    InApproval: "Em Aprovação",
    Pending: "Pendente",
    Canceled: "Cancelado"
}